import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Icon, Image, Modal, Table } from 'semantic-ui-react';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import * as moment from 'moment';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import { SelectField, TextField } from '../common/FormFields';
import { dateOptions } from './photos.constants';

const PhotoSearch = ({
  count,
  page,
  photos,
  query,
  setPhotoQuery,
  searchPhotos,
  getUsers,
  users,
  setPhotoPage,
  handleSelect,
  label,
  icon,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    searchPhotos(query);
    getUsers();
  }, []);

  const handleSubmit = currentQuery => {
    searchPhotos(currentQuery);
    setPhotoQuery(currentQuery);
  };

  const handleClick = photo => {
    handleSelect(photo);
    setOpen(false);
  };

  const getUrl = url => {
    if (!url || !url.includes('image/upload/')) return url;
    return url.replace('upload', 'upload/w_100');
  };

  return (
    <Formik initialValues={{ altTag: '', uploadDatetime: '', addedById: '' }} onSubmit={handleSubmit}>
      {formik => (
        <Modal
          size="fullscreen"
          closeIcon
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          trigger={<Button as="a" icon={icon || 'search'} content={label || 'Photo'} />}
        >
          <Modal.Header>
            <Icon name="picture" />
            Select Photo
          </Modal.Header>
          <Modal.Content scrolling>
            <Form>
              <Form.Group>
                <Form.Field width={4}>
                  <label>Alt tag</label>
                  <TextField
                    name="altTag"
                    id="altTag"
                    formik={formik}
                    onChange={formik.handleChange}
                    value={formik.values.altTag || ''}
                  />
                </Form.Field>

                <Form.Field width={4}>
                  <label>Upload datetime</label>
                  <SelectField
                    name="uploadDatetime"
                    id="uploadDatetime"
                    options={dateOptions}
                    formik={formik}
                    onChange={formik.handleChange}
                    value={formik.values.uploadDatetime || ''}
                  />
                </Form.Field>

                <Form.Field width={4}>
                  <label>Added by</label>
                  <SelectField
                    name="addedById"
                    id="addedById"
                    value={formik.values.addedById || ''}
                    options={users}
                    formik={formik}
                  />
                </Form.Field>

                <Form.Field style={{ paddingTop: 20 }}>
                  <Button as="a" onClick={formik.submitForm} content="Search" default fluid />
                </Form.Field>

                <Form.Field style={{ paddingTop: 20 }}>
                  <Button
                    as="a"
                    onClick={() => {
                      formik.resetForm();
                      setPhotoQuery({
                        uploadDatetime: 'Any',
                        altTag: '',
                        missingCredits: 'All',
                        onlyPhoto: 'All',
                        addedById: '',
                      });
                      searchPhotos();
                      setPhotoPage(1);
                    }}
                    content="Reset"
                    default
                    fluid
                  />
                </Form.Field>
                <Form.Field style={{ paddingTop: 20 }}>
                  <Button as="a" target="_blank" href="/photos/add" content="Add" />
                </Form.Field>
              </Form.Group>
            </Form>
            <Formik initialValues={query} enableReinitialize onSubmit={handleSubmit}>
              {formik => (
                <>
                  <div>
                    <Table size="small" compact="very" selectable celled>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell></Table.HeaderCell>
                          <Table.HeaderCell width="4">Alt tag</Table.HeaderCell>
                          <Table.HeaderCell>Thumbnail</Table.HeaderCell>
                          <Table.HeaderCell>Credit</Table.HeaderCell>
                          <Table.HeaderCell>Upload datetime</Table.HeaderCell>
                          <Table.HeaderCell>Added by</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {photos?.map((photo, idx) => (
                          <Table.Row key={idx}>
                            <Table.Cell>
                              <Button content="Select" size="mini" onClick={() => handleClick(photo)} />
                            </Table.Cell>
                            <Table.Cell>{photo?.altTag}</Table.Cell>
                            <Table.Cell>
                              <Image
                                as="div"
                                src={`https://res.cloudinary.com/culturemap-com/${getUrl(photo.original)}`}
                                size="tiny"
                                style={{ width: 'auto' }}
                              />
                            </Table.Cell>
                            <Table.Cell>{photo?.credit}</Table.Cell>
                            <Table.Cell>
                              {moment(photo?.uploadDatetime).format('LL')} <br />{' '}
                              {moment(photo?.uploadDatetime).format('h:MM A')}
                            </Table.Cell>
                            <Table.Cell>
                              {photo?.addedBy?.firstName} {photo?.addedBy?.lastName}
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </div>
                </>
              )}
            </Formik>
          </Modal.Content>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  current: selectors.photos.current(state),
  count: selectors.photos.count(state),
  page: selectors.photos.page(state),
  photos: selectors.photos.photos(state),
  users: selectors.photos.userOptions(state),
  query: selectors.photos.query(state),
});

const mapDispatchToProps = dispatch => ({
  getPhotos: bindActionCreators(actions.photos.getPhotos, dispatch),
  getPhotoById: bindActionCreators(actions.photos.getPhotoById, dispatch),
  searchPhotos: bindActionCreators(actions.photos.searchPhotos, dispatch),
  getUsers: bindActionCreators(actions.photos.getUsers, dispatch),
  setPhotoPage: bindActionCreators(actions.photos.setPhotoPage, dispatch),
  setPhotoQuery: bindActionCreators(actions.photos.setPhotoQuery, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PhotoSearch);
